import React, { useEffect } from 'react'
import "./BallotRow.css"
import { useNavigate } from 'react-router-dom'
import countIcon from "../../../../assets/icons/vote-count.svg"
import CountIcon from './CountIcon';
import requestHandler from '../../../../utils/requestHandler'
import { UserAuth } from '../../../../context/AuthContext';

export default function BallotRow({title,type,id, parentID, voters}) {
    const navigate = useNavigate();
    const { user } = UserAuth();

    function navigateToBallot() {
        navigate(`/ballot/${parentID === 0 ? id : type === "closed" ? parentID : id}`)
    }

    return <div className={`ballot-row-container ballot-row-${type}`} onClick={navigateToBallot}>
        <h2>{title}</h2>
        <div className='ballot-row-count'>
            <CountIcon fillColor={type==="closed" ? "var(--green)" : "var(--eestec-red)"}/>
            <p> {voters} </p>
        </div>
    </div>
}